import React from 'react'
import { Field, reduxForm } from 'redux-form'
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import './Services.css';
import CustomCheckBox from './CustomCheckBox';
import Captcha from '../../elements/contact/Captcha';
import SubmissionErrorNotice from '../../elements/contact/SubmissionErrorNotice';
import SubmissionButtonContent from '../../elements/contact/SubmissionButtonContent';
import { validateIdentity, validateLocation } from '../../apis/leadValidation';

function validate(values) {
    return { ...validateIdentity(values, true), ...validateLocation(values, true) };
}

function renderField({ input, customAS, label, customRows, type, placeholder, meta: { touched, error } }){
 
      return(
          <>
            <Form.Label>{label}</Form.Label>
            <Form.Control  {...input} 
            placeholder={placeholder} 
            type={type}
            as={customAS === null? null : customAS}
            rows={customRows === null? null : customRows}
            isInvalid={touched && error}
            isValid={touched && !error}
            className="shadow-sm"
            />
            <Form.Control.Feedback type="invalid">
                  {error}
              </Form.Control.Feedback>
          </>
      );
  }
var RealEstateContactForm = (props) =>{
    const { handleSubmit, submitting, error } = props;


    function handleFormSubmit(formValues){
        return props.handleFormSubmit(formValues);
    }
  
    return (
        <Form noValidate onSubmit={handleSubmit(handleFormSubmit)}>
          <SubmissionErrorNotice message={error} />
          <hr />
             
            <div className="mb-3 shadow contact-section">
            <span className="d-flex justify-content-center"><h5 className="fw-light">Kontaktní informace</h5></span>
            <span className="d-flex justify-content-center fw-light small-text-description">(Zadejte adresu nemovitosti)</span>
                <Form.Group className="space-bottom">
                    <Row>
                        <Col>
                            <Field name="firstName" type="text" component={renderField} placeholder="* Jméno"/> 
                        </Col>
                        <Col>
                            <Field name="lastName"  type="text" component={renderField} placeholder="* Příjmení" /> 
                        </Col>
                    </Row>
                </Form.Group>
         
                <Form.Group className="space-bottom">
                
                    <Field name="email" type="email" component={renderField}  placeholder="* E-mail"/>
                </Form.Group>
                <Form.Group className="space-bottom">
                <Form.Group className="space-bottom">
                    <Field name="tel" type="tel" component={renderField}  placeholder="* Telefon: např. 111 222 333"/>
                </Form.Group>
                <Row>
                        <Col>
                    <Field name="city" type="text" component={renderField}  placeholder="Město"/>
                    </Col>
                        <Col>
                        <Field name="zip" type="text" component={renderField}  placeholder="* PSČ"/>
                        </Col>
                    </Row>
                </Form.Group>
                <Form.Group className="space-bottom">
                
                  <Field name="adress" type="text" component={renderField}  placeholder="* Ulice a č.p."/>
                </Form.Group>
                
                
        </div>
        <Form.Group className="small-space-bottom">
        <CustomCheckBox name="souhlas" feedback="Potvrďte seznámení s podmínkami a informacemi o zpracování údajů." privacyAgreement={true}/>
        </Form.Group>
            <Row className="mb-3">
            <Form.Group as={Col} md="8" className="small-space-bottom">
            <Field name='captcharesponse' component={Captcha}/>
            </Form.Group>
            <Form.Group as={Col} className="d-flex justify-content-end" md="4">
                <Button size="lg" block type="submit" disabled={submitting} aria-busy={submitting}
                    variant="outline-primary"
                    className="fw-light shadow-lg next-button border-0 ">
                    <SubmissionButtonContent submitting={submitting}>Odeslat žádost</SubmissionButtonContent>
                </Button>
            </Form.Group>
            </Row>
        </Form>
    )
}

export default reduxForm({
    form: 'realEstateContactForm',
    validate            // <--- validation function given to redux-form
  })(RealEstateContactForm)


